var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperatingTimes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 22,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#699D8C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 30,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#699D8C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 22,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#699D8C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 30,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#699D8C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 22,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#699D8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 10H32.5C34.7091 10 36.5 11.7909 36.5 14V20.231C37.1864 20.3595 37.8545 20.54 38.5 20.7682V14C38.5 10.6863 35.8137 8 32.5 8H12.5C9.18629 8 6.5 10.6863 6.5 14V34C6.5 37.3137 9.18629 40 12.5 40H22.165C21.8143 39.3629 21.5136 38.6945 21.2682 38H12.5C10.2909 38 8.5 36.2091 8.5 34V14C8.5 11.7909 10.2909 10 12.5 10Z",
    fill: "#699D8C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 31,
    width: 2,
    height: 5,
    rx: 1,
    fill: "#699D8C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 36,
    width: 2,
    height: 4,
    rx: 1,
    transform: "rotate(-90 33.5 36)",
    fill: "#699D8C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 14,
    width: 28,
    height: 2,
    fill: "#699D8C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12.5,
    width: 7,
    height: 3,
    rx: 1.5,
    transform: "rotate(-90 14 12.5)",
    fill: "#699D8C",
    stroke: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 12.5,
    width: 7,
    height: 3,
    rx: 1.5,
    transform: "rotate(-90 28 12.5)",
    fill: "#699D8C",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34,
    r: 7,
    stroke: "#699D8C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatingTimes);
export default __webpack_public_path__ + "static/media/operating-times.525b7e76e7bdb734721f831992d5b7ec.svg";
export { ForwardRef as ReactComponent };